import { Box, styled } from '@mui/material';

export const DialogFormFieldContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});
